import { ValidarRut } from "../ValidarRut";

/**
 * Utilidades locales de RUT para el mockup de cotizaciones.
 * Reutiliza ValidarRut existente del proyecto.
 */

export const cleanRut = (rut = "") =>
	String(rut)
		.replace(/\./g, "")
		.replace(/\s/g, "")
		.toUpperCase();

/**
 * Formato visual XX.XXX.XXX-X
 */
export const formatRut = (rut = "") => {
	const cleaned = cleanRut(rut).replace(/[^0-9K]/gi, "");
	if (!cleaned) return "";

	const body = cleaned.slice(0, -1);
	const dv = cleaned.slice(-1);
	if (!body) return dv;

	const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	return `${withDots}-${dv}`;
};

/**
 * Normaliza a formato sin puntos esperado por ValidarRut: XXXXXXXX-X
 */
export const normalizeRutForValidation = (rut = "") => {
	const cleaned = cleanRut(rut);
	if (!cleaned.includes("-")) {
		if (cleaned.length < 2) return cleaned;
		return `${cleaned.slice(0, -1)}-${cleaned.slice(-1)}`;
	}
	return cleaned.replace(/\./g, "");
};

export const isValidRut = (rut = "") => {
	const normalized = normalizeRutForValidation(rut);
	if (!normalized || normalized.length < 3) return false;
	return ValidarRut.validaRut(normalized);
};

export const getRutValidationMessage = (rut = "") => {
	if (!rut || !String(rut).trim()) return "El RUT es obligatorio.";
	if (!isValidRut(rut)) return "El RUT ingresado no es válido. Verifica el dígito verificador.";
	return "";
};
